export function isStaging() {
  return new RegExp('^\\S*\\.jira-dev\\.com$').test(globalThis.location.host);
}
